import React from 'react';
import {Flex} from "../common_style/flex";
import {FontStyles} from "../constants";
import {Background, Frame} from "./dialog_styles";
import {Span} from "../common_style/text";
import {Button, ButtonOutline} from "../common_style/button";


export function Dialog(props) {
    return <Background>
        <Frame>
            <Flex style={{margin: '127px'}} column hAlign={'center'}>
                {props.children}
                {!!props.onCancel ?
                    <Flex hAlign={'space-between'} wmax style={{marginTop: '35px'}}>
                        <ButtonOutline onClick={props.onCancel}>{props.cancel}</ButtonOutline>
                        <Button onClick={props.onConfirm}>{props.confirm}</Button>
                    </Flex> : <Button onClick={props.onConfirm}>{props.confirm}</Button>
                }
            </Flex>
        </Frame>
    </Background>
}

export default Dialog;